'use client';

import { Check, Moon, Palette, Sun } from 'lucide-react';
import { useTheme } from '../../hooks/useTheme';
import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from './dropdown-menu';

/**
 * THE appearance control — a `Theme ▸ Light / Dark` submenu for any user menu.
 *
 * It is a component rather than a copied block because the staff app had NO
 * theme control at all: its pre-paint script hardcoded dark and nothing could
 * change it. Extracting the console's submenu is what let both menus offer the
 * same choice without either owning the other's identity rows.
 *
 * Renders inside a `DropdownMenuContent`.
 */
export function ThemeMenuSub() {
  const { theme, setTheme } = useTheme();

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger className="gap-2 [&>svg]:hidden px-2 py-1.5 h-8">
        <Palette className="w-4 h-4 flex-shrink-0" />
        <span className="text-sm">Theme</span>
        <span className="ml-auto text-xs text-ink-supporting capitalize">{theme}</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="w-48 p-1" sideOffset={2} alignOffset={-4}>
        <DropdownMenuLabel className="px-2 py-1.5 text-xs font-medium">Appearance</DropdownMenuLabel>
        <DropdownMenuItem
          onClick={() => setTheme('light')}
          className="flex items-center justify-between cursor-pointer px-2 py-1.5 h-8"
        >
          <div className="flex items-center gap-2">
            <Sun className="w-4 h-4" />
            <span className="text-sm">Light</span>
          </div>
          {theme === 'light' && <Check className="h-3.5 w-3.5 text-primary flex-shrink-0" />}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => setTheme('dark')}
          className="flex items-center justify-between cursor-pointer px-2 py-1.5 h-8"
        >
          <div className="flex items-center gap-2">
            <Moon className="w-4 h-4" />
            <span className="text-sm">Dark</span>
          </div>
          {theme === 'dark' && <Check className="h-3.5 w-3.5 text-primary flex-shrink-0" />}
        </DropdownMenuItem>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
}
